import * as analytics from '@opendoor/shared-fe/build/analytics';

// TODO: Store variables into redux or an equivalent to avoid having to parse them here
export const matchLeadToken = (location) => {
  if (!location) {
    return undefined;
  }
  const fragments = location.match(/^\/seller-lead\/([-\w]+)/);
  if (!fragments || fragments[1] === 'address-manual') {
    return undefined;
  }
  const uuid = fragments[1] || fragments[2];
  if (uuid.length !== 36) {
    const extras = {
      url: location,
      uuid,
      length: uuid.length,
    };

    analytics.trackEvent('seller-flow', 'error', 'bad-uuid', extras);
  }

  return uuid;
};

export const matchSellerFlowSlug = (location) => {
  if (!location) {
    return undefined;
  }
  const fragments = location.match(/^\/seller-lead\/([-\w]+)\/([-\w]+)$/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};

export const matchSellerFlowPageName = (location) => {
  if (!location) {
    return undefined;
  }
  const fragments = location.match(/^\/seller-lead\/([-\w]+)\/p\/([-\w]+)$/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};

export const matchTrackingKeywords = (queryParams) => {
  const fragments = queryParams && queryParams.match(/keywords=([\w-]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const matchInAppQueryParam = (queryParams) => {
  const fragments = queryParams && queryParams.match(/app=(\d+)/);
  if (!fragments) {
    return false;
  }
  return !!fragments[1];
};

export const matchChannelQueryParam = (queryParams) => {
  const fragments = queryParams && queryParams.match(/channel=([\w-]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const matchUtmSourceQueryParam = (queryParams) => {
  const fragments = queryParams && queryParams.match(/utm_source=([-\w]+)/);
  if (!fragments) {
    return '';
  }
  return fragments[1];
};

export const matchResaleOfferPortalPageName = (location) => {
  const fragments = location.match(/\/(makeoffer|makeoffers|make-offer|make-offers)\/([-\w]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};
